module.exports = __webpack_public_path__ + "static/media/20ECE28.34faf051.jpg";